import Div100vh from "react-div-100vh"
import styled from "styled-components/macro"
// import { device } from "../../theme/device"

export const ApartmentFinderHolder = styled(Div100vh)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100vw;
  background-color: #8eb1c9;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`
